const updateReferralListings = crm => async ({ fieldName, subscriber, dispatchWrapper, getState }) => {
	const { data } = getState();
	const listings = data[fieldName] || [];
	const listingIds = listings.map(listing => listing.recId);

	dispatchWrapper("handleFormChange", [subscriber, "Int", listingIds]);
};

export default updateReferralListings;
